import '../Sass/App.scss';
import React, { useContext } from 'react';
import { useDrop } from 'react-dnd'
import { MWContext } from '../Contexts/MWContext';

export function Turn(props) {

    const { IMAGE_ROOT } = useContext(MWContext)
    let TURN_ROOT = IMAGE_ROOT + "/icons/";

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card','ml-card','viral-card'],
        hover: () => {
            props.changeTurn(props.codebaseId)
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    return (
        <div ref={dropRef} className={ props.codebaseId == props.playerInFocus ? 'turn-bar' : 'turn-bar-inactive' } onClick={() => props.changeTurn(props.codebaseId)}><span></span> {props.nickname}</div>
        // <img src={props.codebaseId == props.playerInFocus ? TURN_ROOT + props.icon + '-white.png' : TURN_ROOT + props.icon + '-grey.png'} />
    )
}